import React from "react";
import './Calculator.css';

import { Slider } from '@material-ui/core';

function CCSlider({value,onChange, questionConfig, children}) {



return (
    <div className='cc-question' id={'question-' + questionConfig.rootAlias + questionConfig.alias} key={'question-' + questionConfig.rootAlias + questionConfig.alias}>
      <div className='cc-question-title'> {questionConfig.name} </div>
      <div className='cc-question-description'> {questionConfig.description} </div>
      

      <div className='indent'>
        
      {children}

      { questionConfig.getLabel && <div className='cc-input-label'> {questionConfig.getLabel(value,questionConfig)} </div> }

        <Slider
          id={'slider-' + questionConfig.alias}
          value={value} valueLabelDisplay={questionConfig.valueLabelDisplay}
          step={questionConfig.step} min={questionConfig.min} max={questionConfig.max} marks={questionConfig.marks}
          onChange={(event,val) => onChange(event, val,questionConfig.alias, questionConfig.rootAlias)}
          valueLabelFormat={questionConfig.valueLabelFormat}
        />

        <div className='sub-labels'>
            <span className='left'>{questionConfig.subLabels[0] }</span>
            <span className='right'>{questionConfig.subLabels[1] }</span>
        </div>

      </div>
    </div>
  );
}

export default CCSlider;
